/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-explicit-any */
import cn from "clsx";
import styles from "./reviews.module.scss";
import IntlRating from "./components/rating";
import BreadCrumb from "@/components/breadCrumb";
import IntlUploadMedia from "./components/upload";
import CustomTextarea from "./components/customTextArea";
import { Helmet } from "react-helmet";
import { SkuItem, SkuScoreItem, ServiceScoreList, CommentContentResponse } from "@/app/csr-src/apis/profile/review.interface";
import { observer } from "mobx-react";
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { MESSAGE } from "@/app/csr-src/data/consts/message";
import { styled as muiStyled } from "@mui/material/styles";
import { useLocation, useNavigate, useBlocker } from "react-router-dom";
import { Button, Checkbox, DialogContent, DialogActions, DialogTitle } from "@mui/material";
import { fetchApplyCommentInfo, saveComment } from "@/app/csr-src/apis/profile/review.api";
import IMAGEAPI_TYPE from "@/constants/imageApiType";
import { imageUtil } from "@/utils/imageUtil";
import UKToast from "@/components/UKToast/index";
import UKDialog from "@/components/UKDialog";
import { sendPv as reviewDetailSendPv, sendClickTrack as reviewDetailSendClickTrack, EXPOSURE_RECORD as REVIEW_DETAIL_EXPOSURE_RECORD } from "@/tracks/25337";

interface SkuItemParams {
  skuId: string;
  content?: string;
  scoreList: number[];
  imageList?: string[];
  ugcVideoList?: string[];
}

interface FormParams {
  orderId: string;
  anonymous: boolean;
  skuList: SkuItemParams[];
}

interface SkuRating {
  num: number | null;
  scoreIndex: number;
  skuIndex: number;
  skuId: string;
}
interface SaveResult {
  saveResult?: boolean;
}

interface MediaType {
  [key: string]: Record<string, string[]>;
}
const SubmitButton = muiStyled(Button)(() => ({
  width: "480px",
  lineHeight: "48px",
  background: "linear-gradient(90deg, #FF475D 0%, #FF0F23 100%)",
  color: "#fff",
  padding: 0,
  cursor: "pointer",
  // backgroundColor: '#999',
  "&:hover": {
    background: "linear-gradient(90deg, #FF475D 0%, #FF0F23 100%)",
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    opacity: 0.5,
    cursor: "no-drop",
    color: "#fff",
  },
}));

const formValidate = (
  {
    value,
    serviceScore, // 总评星星数组
  }: {
    value: FormParams;
    serviceScore: (number | null)[];
  },
  success?: (transformedValue: FormParams) => void,
  error?: (type: number, v?: { skuId?: any; skuIndex?: any; scoreList?: any }) => void,
) => {
  let count = 0;
  let hasComplete = true;
  let skuID: any = null;
  let skuIndex: any = null;
  let scoreData: any = null;
  // 总评
  if (!serviceScore.length || !serviceScore[0] || !serviceScore[1]) {
    // 0 表示至少一个sku评分完整
    error?.(0, { skuId: "-1", skuIndex: 0, scoreList: serviceScore });
    return false;
  }

  // 单个 skuId 评
  if (value?.skuList.length > 0) {
    value.skuList?.forEach((element: SkuItemParams, index: number) => {
      const scoreList = element.scoreList || [];
      if (scoreList[0] && scoreList[1]) {
        count++;
      } else if (!(scoreList[0] === 0 && scoreList[1] === 0) && (!scoreList[0] || !scoreList[1])) {
        // 至少需要有一个sku有完整评分
        // 都没有评分 --- 锚点到第一条
        if (!skuID) {
          skuID = element.skuId;
          skuIndex = index;
          scoreData = element.scoreList;
        }
        error?.(1, { skuId: skuID, skuIndex: skuIndex, scoreList: scoreData });
        hasComplete = false;
        return false;
      }
      return null;
    });
  } else {
    error?.(1, { skuId: "-2", skuIndex: skuIndex, scoreList: scoreData });
    return;
  }

  if (count >= 1 && hasComplete) {
    let valueSkuList = value.skuList;
    valueSkuList = value.skuList.filter((item) => item.scoreList.length === 2 && item.scoreList?.[0] && item.scoreList?.[1]);
    value.skuList = valueSkuList;
    success?.(value);
    return true;
  } else {
    error?.(1, { skuId: skuID || "-1", skuIndex: skuIndex, scoreList: scoreData });
    return false;
  }
};
const formIsThereValue = ({ value }: { value: FormParams }) => {
  // eslint-disable-next-line no-debugger
  let flag: boolean = false;
  if (value.skuList && value.skuList.length > 0) {
    value.skuList.forEach((element: SkuItemParams) => {
      if (
        element.content ||
        (element.scoreList && element.scoreList.length > 0) ||
        (element.ugcVideoList && element.ugcVideoList.length > 0) ||
        (element.scoreList && element.scoreList.length > 0)
      ) {
        flag = true;
      }
    });
  }
  return flag;
};

const WaitingReviewDetail = observer(() => {
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [data, setData] = useState<CommentContentResponse | null>(null);
  const orderId = queryParams.get("orderId") || ""; // 获取订单ID
  const skuID = queryParams.get("skuId") || ""; // 获取skuId
  const fullStar = queryParams.get("fullStar") || ""; // 是否全星评价
  const [serviceScore, setServiceScore] = useState<(number | null)[]>([]);
  const [ratingNum, setRatingNum] = useState<number>(0);
  const [currentSkuMedia, setCurrentSkuMedia] = useState<Record<string, Record<string, string[]>> | null>(null);
  const [uploadLoading, setUploadLoading] = useState<boolean>(false);
  const [uploadError, setUploadError] = useState<boolean>(false);
  const [formParams, setFormParams] = useState<FormParams>({
    orderId,
    anonymous: false,
    skuList: [],
  });
  const navigate = useNavigate();
  /* ------------------------------------- 路由拦截 --------------------------------------------- */
  const [open, setOpen] = useState(false);
  const [isFormThereValue, setIsFormThereValue] = useState(false);
  const [submitDontIntercept, setSubmitDontIntercept] = useState(true);
  const blocker: any = useBlocker(({ currentLocation, nextLocation }) => isFormThereValue && currentLocation.pathname !== nextLocation.pathname);

  useEffect(() => {
    /** PV-评价编辑页 */
    reviewDetailSendPv.Review_Edit({ orderId: `${orderId}` || "-100" });
  }, [orderId]);

  // 拦截 router 打开挽留提示
  useEffect(() => {
    if (isFormThereValue && submitDontIntercept) {
      if (blocker.state === "blocked") {
        setOpen(true);
      }
    } else {
      if (!submitDontIntercept) {
        blocker?.proceed();
      }
      setOpen(false);
    }
  }, [blocker]);
  // 拦截 window 打开挽留提示
  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      // 如果表单有内容 阻止跳转
      if (isFormThereValue) {
        event.preventDefault();
        event.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isFormThereValue, blocker]);

  useEffect(() => {
    setIsFormThereValue(formIsThereValue({ value: { ...formParams } }));
  }, [currentSkuMedia, formParams]);
  const closeMindDialog = (reason: string) => {
    if (reason === "escapeKeyDown" || reason === "backdropClick" || reason === "close" || reason === "esc") {
      return;
    }
  };

  /* ------------------------------------- 路由拦截 --------------------------------------------- */
  const onTextareaChange = (value: string, skuId: string, skuIndex: number) => {
    setFormParams((preState) => {
      const newState = { ...preState };
      const { skuList } = newState;
      const common = {
        skuId,
        content: value,
      };
      if (!skuList[skuIndex]) {
        skuList[skuIndex] = {
          ...common,
          scoreList: [],
        };
      } else {
        skuList[skuIndex] = { ...skuList[skuIndex], ...common };
      }
      return newState;
    });
  };
  const handleCheckChange = () => {
    setFormParams({ ...formParams, anonymous: !formParams.anonymous });
  };
  const init = async () => {
    if (skuID) {
      // 获取sku维度的商品评价
      // const res = await fetchApplyCommentInfo({ skuId: skuID });
      const res: any = await fetchApplyCommentInfo({ orderId: orderId });
      if (res?.commentSkuList && res?.commentSkuList.length > 0) {
        setData(res);
        return;
      } else {
        window.location.href = "/profile/my-reviews";
      }
      const commentList: any = res?.commentSkuList.filter((item: SkuItem) => item.skuId == skuID);
      res.commentSkuList = commentList;
      setData(res);
      if (!fullStar) {
        return;
      }
      const num = Number(fullStar);
      setRatingNum(num);
      if (num) {
        // setServiceScore([5, num]);
        setServiceScoreFn(1, num);
        setServiceScoreFn(2, num);
        // 如果评分是5星，则星星暂满
        setFormParams((preState) => {
          const newState = { ...preState };
          res?.commentSkuList?.map((item: SkuItem, index: number) => {
            const common = {
              skuId: item.skuId,
              scoreList: [num, num],
            };
            if (!newState.skuList[index]) {
              newState.skuList[index] = {
                ...common,
              };
            } else {
              newState.skuList[index] = { ...newState.skuList[index], ...common };
            }
          });
          return newState;
        });
      }
      return;
    }
    const res: any = await fetchApplyCommentInfo({ orderId: orderId });
    if (res?.commentSkuList && res?.commentSkuList.length > 0) {
      setData(res);
    } else {
      // 如果没有数据跳转到个人中心评价页面
      window.location.href = "/profile/my-reviews";
    }
  };

  const onUploadMedia = (mediaList: Record<string, string[]> | null, skuId: string) => {
    setCurrentSkuMedia({ ...(currentSkuMedia || {}), [skuId]: mediaList } as any);
  };
  const targetRef = useRef<any>({});
  const targetRefAll = useRef<any>(null);
  const [starParams, setStarParams] = useState<any>({});
  const [serviceScoreAll, setServiceScoreAll] = useState<any>(["0", "0"]);
  const onSubmit = () => {
    reviewDetailSendClickTrack.Review_Edit_Publish({ orderId: `${orderId}` || "-100" });
    if (uploadLoading) {
      UKToast.show({
        icon: "warning",
        content: t("upload.waitUploadMsg"),
      });
      return;
    }
    if (uploadError) {
      UKToast.show({
        icon: "warning",
        content: t("upload.uploadError"),
      });
      return;
    }
    setSubmitDontIntercept(false);
    formValidate(
      { value: { ...formParams }, serviceScore },
      async (value: FormParams) => {
        const promiseArr: unknown[] = [];
        const { orderId, skuList, anonymous } = value;
        skuList.forEach((item: SkuItemParams) => {
          const scoreList = [...serviceScore, ...(item.scoreList || [])];
          promiseArr.push(
            new Promise((resolve, reject) => {
              saveComment({
                orderId,
                skuId: item.skuId,
                scoreList,
                anonymous,
                content: item.content,
                imageList: currentSkuMedia?.[item.skuId]?.["0"] || [],
                ugcVideoList: currentSkuMedia?.[item.skuId]?.["1"] || [],
              })
                .then((data) => resolve(data))
                .catch((err) => reject(err));
            }),

            // Promise.resolve(
            // ),
          );
        });
        const res = await Promise.all(promiseArr);
        const result = res?.filter((value, index: number, array: unknown[]) => (value as SaveResult)?.saveResult);

        if (result.length > 0) {
          navigate(`/ReviewResult?orderId=${orderId}`, { replace: true });
        } else {
          UKToast.show({
            icon: "error",
            content: t("common.pageStatus.serverError"),
          });
        }
      },
      (type, props) => {
        UKToast.show({
          icon: "warning",
          content: t("review.validateErrorMsg"),
        });

        // 锚点到总评价
        if (props?.skuId === "-1") {
          setServiceScoreAll(serviceScore);
          targetRefAll.current.scrollIntoView({ behavior: "smooth" });
          return;
        }
        // 锚点到单独的 skuId 商品
        if (props?.skuId === "-2") {
          setStarParams({
            skuId: data!.commentSkuList[0]?.skuId,
            scoreList: [],
          });
          targetRef.current[data!.commentSkuList[0]?.skuId].scrollIntoView({ behavior: "smooth" });
          return;
        }
        // 锚点到单独的 skuId 商品
        if (props?.skuId) {
          setStarParams(props);
          targetRef.current[props?.skuId].scrollIntoView({ behavior: "smooth" });
        }
      },
    );
  };
  const onRatingChange = (type: number, num: number | null, title: string) => {
    reviewDetailSendClickTrack.Review_Edit_Star({ orderId: `${orderId || "-100"}`, skuid: `${skuID || "-100"}`, title: `${title}` });
    if (type === 0 && num) {
      setServiceScoreFn(1, num);
      setServiceScoreFn(2, num);
      setFormParams((preState) => {
        const newState = { ...preState };
        data?.commentSkuList?.map((item: SkuItem, index: number) => {
          const common = {
            skuId: item.skuId,
            scoreList: [num, num],
          };
          if (!newState.skuList[index]) {
            newState.skuList[index] = {
              ...common,
            };
          } else {
            newState.skuList[index] = { ...newState.skuList[index], ...common };
          }
        });
        return newState;
      });
    }
    if (type !== 0) {
      let state: any = [];
      setServiceScore((preState) => {
        const newState = [...preState];
        newState[type - 1] = num as number;

        if ((num as number) > 0) {
          state = newState;
        } else {
          state = "0";
        }

        return newState;
      });
      setServiceScoreAll(state);
    }
  };

  const setServiceScoreFn = (type: number, num: number | null) => {
    setServiceScore((preState) => {
      const newState = [...preState];
      newState[type - 1] = num as number;
      return newState;
    });
  };

  const onSkuRatingChange = ({ num, skuIndex, scoreIndex, skuId }: SkuRating) => {
    setFormParams((preState) => {
      const newState = { ...preState };
      const { skuList } = newState;
      if (!skuList[skuIndex]) {
        skuList[skuIndex] = {
          skuId: skuId,
          scoreList: [],
        };
      }
      skuList[skuIndex].scoreList[scoreIndex] = num ?? 0;
      return newState;
    });
  };

  // 上传图片时候的回调
  const onUploadFn = (item: any) => {
    reviewDetailSendClickTrack.Review_Edit_AddPhoto({ orderId: `${orderId}`, skuid: `${skuID}` });
    if (item.isLoading) {
      // 正在上传
      setUploadLoading(true);
    } else {
      setUploadLoading(false);
      // 上传完成
      if (item.showRetryButtons && Object.keys(item.showRetryButtons).length > 0) {
        // 有上传失败的
        setUploadError(false);
        for (const key in item.showRetryButtons) {
          if (Object.prototype.hasOwnProperty.call(item.showRetryButtons, key)) {
            const element = item.showRetryButtons[key];
            if (element) {
              setUploadError(true);
            }
          }
        }
      } else {
        // 全部都上传成功
        setUploadError(false);
      }
    }
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <div className={styles.write_review_block}>
        <Helmet>
          <title>{`${t("seo.title.shareReview", { orderId: "#" + orderId || "" })} | Joybuy`}</title>
          <meta name="description" content={t("seo.description.shareReview")} />
        </Helmet>
        <BreadCrumb
          list={[
            { name: t("common.pageName.me"), url: "/profile" },
            { name: t("profile.breadCrumb.myReviews"), url: "/profile/my-reviews" },
            { name: t("profile.breadCrumb.review") },
          ]}
        />
        <div className={styles.content_wrapper} ref={targetRefAll}>
          <div className={styles.header}>{t("profile.page.review")}</div>
          <div className={styles.sumary}>
            <div className={styles.colums}>
              <div>
                <span className={styles.label}>{`${t("review.orderId")}: `}</span>
                {data?.orderId}
              </div>
              <div>
                <span className={styles.label}>{`${t("review.orderTime")}: `}</span>
                {data?.orderTime}
              </div>
              {/* 
              // 价格本期没有
              <div>
                <span className={styles.label}>5 item(s):</span>
                <JDIPrice
                  symbol={""}
                  price={"1196.33"}
                  uiType={1}
                  integerStyle={{ fontSize: "16px" }}
                  containerStyle={{ lineHeight: "20px", fontSize: "16px" }}
                />
              </div> */}
            </div>
            <div className={styles.colums}>
              <div className={styles.service}>
                <span>{t("review.quickReview")}</span>
              </div>
              {data?.serviceScoreList?.map((item: ServiceScoreList, index: number) => {
                return (
                  <div className={styles.service} key={index}>
                    <span>{item.name}</span>
                  </div>
                );
              })}
              <div className={styles.sumaryScore}>
                <div
                  exptag={"exp|" + REVIEW_DETAIL_EXPOSURE_RECORD.Review_Edit_Star_Expo}
                  data-exptag-json-param={JSON.stringify({ orderId: `${orderId}` ? `${orderId}` : "-100", skuid: `${skuID}` || "-100", title: "Quickreview" })}
                  data-exptag-config='{"useClick": false, "stay_duration": 0.6, "repeated":false, "area_rate": 0.01}'
                >
                  <IntlRating value={ratingNum} onChange={(num) => onRatingChange(0, num, "Quick review")} />
                </div>
                {data && (
                  <>
                    <div
                      exptag={"exp|" + REVIEW_DETAIL_EXPOSURE_RECORD.Review_Edit_Star_Expo}
                      data-exptag-json-param={JSON.stringify({
                        orderId: `${orderId}` ? `${orderId}` : "-100",
                        skuid: `${skuID}` || "-100",
                        title: `${(data?.serviceScoreList[0]?.name as string) || "-100"}`,
                      })}
                      data-exptag-config='{"useClick": false, "stay_duration": 0.9, "repeated":false, "area_rate": 0.01}'
                    >
                      <IntlRating
                        Highlight={!serviceScoreAll[0]}
                        value={serviceScore[0]}
                        onChange={(num) => onRatingChange(1, num, (data?.serviceScoreList[0]?.name as string) || "-100")}
                      />
                    </div>
                    <div
                      exptag={"exp|" + REVIEW_DETAIL_EXPOSURE_RECORD.Review_Edit_Star_Expo}
                      data-exptag-json-param={JSON.stringify({
                        orderId: `${orderId}` ? `${orderId}` : "-100",
                        skuid: `${skuID}` || "-100",
                        title: `${(data?.serviceScoreList[1]?.name as string) || "-100"}`,
                      })}
                      data-exptag-config='{"useClick": false, "stay_duration": 0.9, "repeated":false, "area_rate": 0.01}'
                    >
                      <IntlRating
                        Highlight={!serviceScoreAll[1]}
                        value={serviceScore[1]}
                        onChange={(num) => onRatingChange(2, num, (data?.serviceScoreList[1]?.name as string) || "-100")}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          {data?.commentSkuList?.map((item: SkuItem, index: number) => {
            return (
              <div className={styles.section} key={index} ref={(el) => {targetRef.current[item.skuId] = el}}>
                <div className={styles.colums}>
                  <div className={styles.graph}>
                    <div className={styles.imgWrapper}>
                      <img src={imageUtil.concatImgUrlWithoutForceHttps(item.skuImage, 120, 120, 70)} alt="" />
                    </div>
                    <p className={cn(styles.title, styles.line2Overflow)}>{item.skuTitle}</p>
                    <p className={styles.dimensions}>{item.propertyExt}</p>
                  </div>
                </div>
                <div className={styles.colums}>
                  <div className={styles.review_form}>
                    {item.skuScoreList?.map((score: SkuScoreItem, scoreIndex) => {
                      return (
                        <p key={score.id} className={styles.form_item}>
                          <span className={styles.textLabel}>{score.name}</span>
                          <IntlRating
                            Highlight={item.skuId == starParams?.skuId && !formParams.skuList[index]?.scoreList[scoreIndex]}
                            value={formParams.skuList[index]?.scoreList[scoreIndex] ?? 0}
                            onChange={(num) =>
                              onSkuRatingChange({
                                num,
                                scoreIndex,
                                skuIndex: index,
                                skuId: item.skuId,
                              })
                            }
                          />
                        </p>
                      );
                    })}
                    <div
                      exptag={"exp|" + REVIEW_DETAIL_EXPOSURE_RECORD.Review_Edit_AddPhoto_Expo}
                      data-exptag-json-param={JSON.stringify({ orderId: `${orderId || "-100"}`, skuid: `${skuID || "-100"}` })}
                      data-exptag-config='{"useClick": false, "stay_duration": 0.6, "repeated":false, "area_rate": 0.01}'
                    >
                      <IntlUploadMedia
                        limitNumber={8}
                        limitVideoNumber={1}
                        data={{ orderId, skuId: item.skuId }}
                        type={"image_video"}
                        moduleType="REVIEW"
                        apiType={IMAGEAPI_TYPE.Reviews}
                        onChange={(media) => {
                          onUploadMedia(media, item.skuId);
                        }}
                        onUpload={(item: any) => onUploadFn(item)}
                      />
                    </div>
                    <div className={styles.commentReply}>
                      <CustomTextarea
                        numStyle={styles.num}
                        onChange={(value) => onTextareaChange(value, item.skuId, index)}
                        placeholder={t("review.enterReview")}
                      />
                      {/* <textarea
                        onChange={(event) => onTextareaChange(event, item.skuId, index)}
                        placeholder={"Please enter your reviews"}
                      ></textarea>
                      <span className={styles.num}>1/1000</span> */}
                    </div>
                  </div>
                </div>
              </div>
            );
          }, [])}

          <div className={styles.publishWrapper}>
            <div className={styles.inner}>
              {false && (
                <>
                  <div className={styles.agree}>
                    <Checkbox
                      checked={formParams.anonymous}
                      onChange={handleCheckChange}
                      inputProps={{ "aria-label": "controlled" }}
                      sx={{
                        "&": {
                          color: "rgba(224, 225, 229, 1)",
                          padding: "6px",
                        },
                        "& .MuiSvgIcon-root": {
                          fontSize: "24px",
                          borderRadius: "5px",
                        },
                      }}
                    />
                    {/* <span className={styles.txt}>Anonymous evaluation</span> */}
                    <span className={styles.txt}>{t("review.anonymous")}</span>
                  </div>
                </>
              )}
              <SubmitButton
                exptag={"exp|" + REVIEW_DETAIL_EXPOSURE_RECORD.Review_Edit_Publish_Expo}
                data-exptag-json-param={JSON.stringify({ orderId: `${orderId}` ? `${orderId}` : "-100" })}
                data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
                onClick={onSubmit}
              >
                {t("review.submitReview")}
              </SubmitButton>
            </div>
          </div>
        </div>
      </div>
      <UKDialog
        open={open}
        onClose={(e: React.MouseEvent<HTMLElement>, r: string) => closeMindDialog(r)}
        showCloseBtn={true}
        sx={{
          "& .MuiDialog-paper": {
            width: "600px", // 设置自定义宽度
            maxWidth: "none", // 取消最大宽度限制
            maxHeight: "534px",
            minHeight: "134px",
          },
        }}
      >
        <DialogTitle>{t("review.leaveReviewTitle")}</DialogTitle>
        <DialogContent>
          <p
            style={{
              width: "100%",
              fontSize: "18px",
              lineHeight: "30px",
              textAlign: "center",
              margin: "18px 0",
            }}
          >
            {t("review.leaveReviewBox")}
          </p>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            disableElevation
            sx={{
              height: "32px",
              fontSize: "14px",
              margin: "16px 8px 10px 0",
              backgroundColor: "#fff", // 自定义背景颜色
              boxShadow: "none",
              color: "#1a1a1a", // 自定义文字颜色
              textTransform: "none",
              border: "1px solid #E0E1E5",
              "&:hover": {
                backgroundColor: "#fefefe", // 悬停时的背景颜色
              },
            }}
            onClick={() => {
              blocker.reset();
              setOpen(false);
            }}
            size="small"
          >
            {t("common.btnText.cancel")}
          </Button>
          <Button
            variant="contained"
            disableElevation
            sx={{
              height: "32px",
              fontSize: "14px",
              margin: "16px 0px 10px 8px",
              backgroundColor: "#FF0F23", // 自定义背景颜色
              color: "#fff", // 自定义文字颜色
              boxShadow: "none",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#FF475D", // 悬停时的背景颜色
              },
            }}
            onClick={() => blocker.proceed()}
            size="small"
          >
            {t("address.confirm")}
          </Button>
        </DialogActions>
      </UKDialog>
    </>
  );
});

export default WaitingReviewDetail;
